
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'reference',
  title: 'Changelog',
  section: 'Changelog',
  description: 'Track changes to Plaid Exchange'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Plaid Exchange Changelog' subtitle={metadata.description} mdxType="Header" />
    <p>{`Plaid Exchange continues to evolve alongside the needs of our integration partners. Below you will find details of the changes made over time to the specification, starting from October 2021.`}</p>
    <p>{`For information regarding changes to the Plaid API, Plaid Link, and major changes to the Plaid Dashboard, SDKs, functionality, and libraries, see the `}<a parentName="p" {...{
        "href": "/docs/changelog"
      }}>{`Plaid changelog`}</a>{`.`}</p>
    <h3 {...{
      "id": "spring-2023"
    }}>{`Spring 2023`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/docs/liabilities/"
        }}>{`Liabilities`}</a>{` support added`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/plaid-exchange/docs/authentication#authorization-flow"
        }}>{`PKCE Support`}</a>{` added`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/plaid-exchange/docs/reference/aggregation#transactionsresponse"
        }}>{`Cursor paging support`}</a>{` added for transactions`}</li>
    </ul>
    <h3 {...{
      "id": "summerfall-2022"
    }}>{`Summer/Fall 2022`}</h3>
    <ul>
      <li parentName="ul">{`Support for OAuth 2.0 (Non-OIDC) added`}</li>
      <li parentName="ul">{`Batch processing for transactions`}</li>
      <li parentName="ul">{`Deprecated support for Credentials authorization`}</li>
    </ul>
    <h3 {...{
      "id": "october-2021"
    }}>{`October 2021`}</h3>
    <ul>
      <li parentName="ul">{`Closed beta for the Exchange Validation Tool`}</li>
      <li parentName="ul">{`Launch of the Plaid Exchange Documentation site`}</li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "spring-2023",
        level: 3,
        title: "Spring 2023",
      },
{
        id: "summerfall-2022",
        level: 3,
        title: "Summer/Fall 2022",
      },
{
        id: "october-2021",
        level: 3,
        title: "October 2021",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
